var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('FlatCard',{scopedSlots:_vm._u([{key:"filter",fn:function(){return [(_vm.$store.getters.profile.role !== 'INTEGRATION')?_c('app-bill-transactions-filter',{on:{"filter":_vm.newFilter}}):_vm._e()]},proxy:true}])},[_c('v-card-text',[_c('FlatTable',{ref:"table",attrs:{"getter":_vm.getter,"headers":_vm.headers,"sort-by":"created_at","sort-desc":""},scopedSlots:_vm._u([{key:"item.type",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.$t(item.type))+" ")]}},{key:"item.amount",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("currency")(item.amount))+" ")]}},{key:"item.origin",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.origin || '---')+" ")]}},{key:"item.destiny",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.destiny || '---')+" ")]}},{key:"item.created_at",fn:function(ref){
var item = ref.item;
return [_c('div',{staticStyle:{"min-width":"120px"}},[_vm._v(" "+_vm._s(_vm.formatDate(item.created_at))+" ")])]}},{key:"item.details",fn:function(ref){
var item = ref.item;
return [_c('TransactionsDetailsButton',{attrs:{"item":item}})]}}])})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }